<div id="create-user" class="modify-user">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'USERUPDATE.TITLE' | translate }}
        </span>
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="user-form">
      <form fxLayout="column" fxFill [formGroup]="changeAvsForm">
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.AVS' | translate }}</mat-label>
            <input autoComplete="on" matInput formControlName="avs" required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>
              {{ 'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate }}</mat-label
            >
            <input
              autoComplete="on"
              matInput
              formControlName="officialLastName"
              required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label
              >{{ 'USERS.SINGLE.INFO.DATEOFBIRTH' | translate }}
            </mat-label>
            <input
              autoComplete="on"
              matInput
              formControlName="dateOfBirth"
              required
              placeholder="dd.mm.yyyy" />
          </mat-form-field>
        </div>
        @if (isInfoIncorrect && !userAlreadyExistsWithAvs) {
          <div>
            <div class="message-box error">
              {{ 'USERUPDATE.INCORRECT-INFO' | translate }}
            </div>
          </div>
        }
        @if (userAlreadyExistsWithAvs) {
          <div>
            <div class="message-box error">
              {{ 'USERUPDATE.AVS-ALREADY-USING' | translate }}
            </div>
          </div>
        }
        @if (isInfoCorrect) {
          <div>
            <div class="message-box success">
              {{ 'USERUPDATE.CORRECT-INFO' | translate }}
            </div>
          </div>
        }
        @if (isBusyVerifyAvs) {
          <div
            class="general-container"
            fxLayout="row"
            fxLayoutAlign="center center">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
        }
        <div
          class="general-container user-button-container"
          fxLayout="row"
          fxLayoutAlign="left left">
          <button
            mat-raised-button
            type="button"
            color="accent"
            class="left-button"
            (click)="getUpiInfo()"
            [disabled]="changeAvsForm.invalid">
            {{ 'NAMEUPDATE.CONFIRMATION.DATA' | translate }}
          </button>
          @if (isInfoCorrect) {
            <button
              mat-raised-button
              type="button"
              color="primary"
              (click)="importNewUserData()"
              [disabled]="changeAvsForm.invalid">
              {{ 'USERUPDATE.IMPORT-DATA' | translate }}
            </button>
          }
        </div>
      </form>
    </div>
  </div>
</div>
